import React from "react";
import { news } from "../mock";
import { ArrowRight, CalendarDays } from "lucide-react";
import useReveal from "../hooks/useReveal";

export default function News() {
  const [ref, inView] = useReveal();

  return (
    <section className="kse-section bg-slate-50">
      <div className="kse-container">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-12">
          <h2 className="kse-h2">{news.title}</h2>
          <button className="kse-btn text-[#2b3aa0] font-semibold self-start">
            Discover More <ArrowRight size={18} />
          </button>
        </div>

        <div ref={ref} className="grid md:grid-cols-3 gap-6">
          {news.items.map((n, i) => (
            <article
              key={n.title}
              className={`group bg-white rounded-3xl overflow-hidden shadow-sm hover:shadow-2xl transition-all duration-300 reveal ${inView ? "in-view" : ""}`}
              style={{ animationDelay: `${i * 0.12}s` }}
            >
              <div className="h-52 overflow-hidden">
                <img src={n.image} alt={n.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
              </div>
              <div className="p-6">
                <p className="flex items-center gap-2 text-slate-400 text-xs mb-3">
                  <CalendarDays size={14} /> {n.date}
                </p>
                <h3 className="text-lg font-bold text-[#1a2a6b] leading-snug group-hover:text-[#2b3aa0] transition-colors">
                  {n.title}
                </h3>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
